import React, {useState} from "react";

import '../overlay.css';



export default function PdfViewerOverlay({ pdfUrl, onClose }) {
    if (!pdfUrl) return null;
  
    return (
      <div className="overlayForCovers">
      <button className="closeButton" onClick={onClose}>Fenster schließen</button>

      <div className="mainImage">
        <iframe
          src={pdfUrl}
          title="PDF"
          width="100%"
          height="100%"
          style={{
            maxHeight: '95%',
            height: '1000px',
            width: '900px',
            maxWidth: '95%',
            border: 'none',
          }}
        />
      </div>
    </div>
    );
  }